import { LoadableLazy } from '@confluence/loadable';

export const GracePeriodBanner = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-grace-period-banner" */ './GracePeriodBanner.tsx'))
			.GracePeriodBanner,
});
